// import CryptoproEsign from 'fm.common.cryptoproEsign';
import { parseCertSubject, getRandomStr, formatInn, promiseRequest } from './utils.js';
import organizationCard from './components/organizationCard.js';
import confirmFrame from './components/confirmFrame.js';
import certStamp from './components/certStamp';
import offcanvasEsign from 'fm.vue.components.offcanvasEsign';
import floatingInput from 'fm.vue.components.floatingInput';
import { cryptoproCert } from 'fm.common.cryptoproCert';

import modalFrameAgreement from 'fm.vue.components.modalFrameAgreement';

// import { email, required, sameAs  } from '@vuelidate/validators'
// import { useVuelidate } from '@vuelidate/core'
import { email, required, sameAs, minLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

import { TEST, TEST_SIGN_2, TEST_AGREEMENTS} from './consts.js';

import Api from './Api.js';
const api = new Api();

const passwordIsSame = {
    $validator: (value, state) => {
        return value === state.password;
    },
    $message: 'Пароли не совпадают'
};

const MOBILE_REGEX = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;

const emailWithMessage = helpers.withMessage('Проверьте правильность введённого адреса электронной почты', email);
const requiredWithMessage = helpers.withMessage('Заполните поле', required);
const minLengthWidthMessage = helpers.withMessage(({ $params }) => `Поле должно иметь длину не менее ${$params.min} символов`, minLength(8));
const mobileValidator = {
    $validator: helpers.regex(MOBILE_REGEX),
    $message: 'Номер введен в неверном формате'
};



// email.$message = 'Проверьте правильность введённого адреса электронной почты';
// required.$message = 'Заполните поле';
// minLength.$message = (_ref) => {
//     console.log(_ref);
//     let { $params } = _ref;
//     return `Поле должно иметь длину не менее  ${$params.min} символов`;
// };

export default {
    setup: () => ({ v$: useVuelidate({
        $autoDirty: true,
    }) }),
    components: {
        'organization-card': organizationCard,
        'confirm-frame': confirmFrame,
        'offcanvas-esign': offcanvasEsign,
        'modal-frame-agreement': modalFrameAgreement,
        'cert-stamp': certStamp,
        floatingInput
    },
    validations () {
        return {
            user: {
                name: { 
                    requiredWithMessage
                },
                email: { requiredWithMessage, emailWithMessage },
                lastName: { requiredWithMessage },
                password: { 
                    requiredWithMessage,
                    minLength: minLengthWidthMessage
                },
                confirmPassword: {
                    sameAsPassword: passwordIsSame,
                    // minLength: minLengthWidthMessage,
                    // requiredWithMessage
                },
                inn: { requiredWithMessage },
                snils: { requiredWithMessage },
                phone: { mobileValidator }
            }
        }
    },
    data: {
        user: {
            email: '',
            name: '',
            secondName: '',
            lastName: '',
            phone: '',
            notes: '',
            login: '',
            password: '',
            confirmPassword: '',
            snils: '',
            inn: '',
            isLeader: false
        },

        orgData: null,
        orgCardHtml: null,

        // crEsigner: null,
        dataCert: null,
        // subjectCert: null,

        confirm: null,
        // isSignerInit: false,
        isEmailConfirm: true,

        requestsState: {
            confirm: false,
            registration: false,
        },

        errors: '',
        certErrors: '',
        // IS_TEST: false,

        esignIsShow: false,
        cert: null,

        agreementsSwitch: {
            user: false,
            org: false,
        },

        certStamp: null,

        userId: null
    },
    watch: {
        confirmFrameUrl: debounce(function(v) {
            this.requestsState.confirm = true;
            $.ajax({
                method: 'GET',
                url: v,
            }).always((response) => {
                this.requestsState.confirm = false;
                this.confirm = response;
            })
        }, 800)
    },
    computed: {
        canRegister() {
            // const requiredFields = ['inn', 'snils', 'email', 'name', 'secondName', 'lastName', 'password', 'confirmPassword'];
            // return requiredFields.every((field) => this.user[field]);
            return !this.v$.$errors.length;
        },

        userAgreementUrl() {
            const result = {
                name: this.fullUserName,
                snils: this.cert ? this.cert.snils() : '',
                inn: this.cert ? this.cert.innIndividual() : '',
            };

            const thereAreAll = Object.values(result).every(Boolean);
            if (!thereAreAll) {
                return '';
            }
            return Object.keys(result).reduce((acc, key) => {
                acc += `&${key}=${result[key]}`
                return acc;
            }, `${this.REGISTRATION_AJAX_URL}?ajax=y&action=template-user-agreement`)
        },

        orgAgreementUrl() {
            if(!this.hasOrganization) {
                return ''
            }

            const result = {
                name: this.fullUserName,
                snils: this.cert.snils(),
                orgName: this.orgData['NAME'],
                orgInn: this.orgData['INN'],
                post: this.user.post,
                inn: this.cert.innIndividual(),
                ogrn: this.cert.ogrn(),
                isLeader: this.user.isLeader ? '1' : '0',
            };
            console.log(result);
            const thereAreAll = Object.values(result).every(Boolean);
            if (!thereAreAll) {
                return '';
            }
            return Object.keys(result).reduce((acc, key) => {
                acc += `&${key}=${result[key]}`
                return acc;
            }, `${this.REGISTRATION_AJAX_URL}?ajax=y&action=template-org-agreement`)
        },

        certIsOk() {
            return !!this.cert;
        },

        hasOrganization() {
            return this.cert && this.cert.isBelongedOrg() && !!this.orgData;
        },

        fullUserName() {
            return [
                this.user.lastName,
                this.user.name,
                this.user.secondName,
            ].join(' ').trim();
        },

        // isReadonlyLastName() {
        //     if (!this.user || !this.subjectCert) {
        //         return false;
        //     }
        //     return this.user.lastName === this.subjectCert['SN'];
        // }
    },
    provide() {},
    methods: {
        closeEsign() {
            this.esignIsShow = false;
            this.cert = null;
        },

        showEsign() {
            this.esignIsShow = true;
        },

        requestDocsAgreement() {
            if(!this.cert) {
                return;
            }
            // let promise;
            // if (this.IS_TEST) {
            //     promise = Promise.resolve(TEST_SIGN);
            // } else {
            //     promise = this.sign(JSON.stringify(this.dataCert));
            // }
            const promise = this.sign(JSON.stringify({
                user: this.user,
                org: this.orgData,
            }));
            // const promise = Promise.resolve(TEST_SIGN_2);

            return promise.then((data) => {
                if (!data) {
                    throw new Error('Не удалось подписать данные');
                }
                return api.getDocsAgreement({
                    esign: data
                })
                // return promiseRequest({
                //     method: 'POST',
                //     url: this.REGISTRATION_AJAX_URL,
                //     data: {
                //         esign: data,
                //         action: 'docs-agreement',
                //         ajax: 'Y'
                //     }
                // })
            })
        },

        updateUserInfoByCert(data) {
            if (!this.cert) {
                return;
            }

            if (this.cert.owner()) {
                this.user.name = this.cert.owner('name');
                this.user.secondName = this.cert.owner('secondName');
                this.user.lastName = this.cert.owner('lastName');
            }
            this.user.snils = this.cert.snils();
            this.user.email = this.cert.email();
            this.user.inn = this.cert.innIndividual();
            this.user.post = this.cert.post();

        },

        onSelectCert(cert) {
            this.certErrors = '';
            this.certStamp = null;

            if (!cert) {
                this.cert = null;
                return;
            }

            if(cert.errors.length) {
                this.certErrors = cert.errors.join('; ');
                return;
            }
                
            this.cert = new cryptoproCert(cert);
                // this.cert = new cryptoproCert(TEST);

            this.updateUserInfoByCert();

            
            this.checkUserExists()
                .then((userId) => {
                    if(userId) {
                        throw new Error(`Существует подтвержденная учетная запись ${this.cert.owner()}. Пожалуйста <a href="#modal-auth-form-header" data-toggle="modal">авторизуйтесь</a>`);
                    }
                    return this.getCertStamp();
                })
                .then(() => {
                    let value = this.cert.innOrg();
                    if(!value && this.cert.ogrn()) {
                        value = this.cert.innIndividual();
                    }
                    if (value) {
                        return this.getOrgInfo(value);
                    } else {
                        this.orgData = null;
                        this.orgCardHtml = null;
                    }
                })
                .catch((err) => this.certErrors = err.message)
                .finally(() => this.v$.$validate())
        },

        updateOrgInfo(data) {
            this.orgInfo = data;
        },

        getOrgInfo(value) {
            if (!value) {
                return;
            }
            this.user.isLeader = false;
            return api.getOrgInfo({value})
                .then((data) => {
                    if(!data || !data.data) {
                        this.orgData = null;
                        this.orgCardHtml = null;
                    }

                    this.orgData = data.data;

                    if(this.orgData && this.orgData['HEAD'] && this.orgData['HEAD']['innfl'] === this.user.inn) {
                        this.user.isLeader = true;
                        if(this.orgData['HEAD']['position']) {
                            this.user.post = this.orgData['HEAD']['position'];
                        }
                    }
                    // this.orgCardHtml = data.html;
                })
        },

        getOrgDataSign() {
            return {
                post: this.cert.post(),
                inn: this.orgData['NAME'] || '',
                kpp: this.orgData['KPP'] || '',
                ogrn: this.orgData['OGRN'] || '',
            };
        },

        registration(userAgreement, organizationConfirm, organizationDataSigned) {
            const formData = new FormData(this.$refs.registrationForm);
            const dataSign = JSON.stringify({
                userAgreement: userAgreement,
                organizationConfirm: organizationConfirm,
                organizationDataSigned: organizationDataSigned,
            });
            formData.append('action', 'registration');
            formData.append('register_submit_button', 'Y');
            formData.append('REGISTER[LOGIN]', getRandomStr());
            // formData.append('REGISTER[PASSWORD]', pass);
            // formData.append('REGISTER[CONFIRM_PASSWORD]', pass);
            formData.append('REGISTER[PERSONAL_NOTES]', dataSign);

            this.requestsState.registration = true;
            $.ajax({
                processData: false,
                contentType: false,
                type: 'POST',
                url: this.REGISTRATION_AJAX_URL || '',
                data: formData
            }).always((response) => {
                if (response.success) {
                    const onClose = () => {
                        if(response.data && response.data.redirectUrl) {
                            window.location.href = response.data.redirectUrl;
                        }
                    };

                    modalPopup({
                        title: 'Регистрация',
                        content:    `<div class="alert alert-success">
                                        <p>Вы успешно зарегестрированы</p>
                                        <p>Подтвердите создание учетной записи пользователя по ссылке отправленной на адрес ${this.user.email}</p>
                                    </div>`,
                        onClose: onClose
                    })

                    // if (response.data && response.data.redirectUrl) {
                    //     window.location.href = response.data.redirectUrl;
                    // } else {
                    //     modalPopup({
                    //         title: 'Регистрация',
                    //         content: '<div class="alert alert-success">Вы успешно зарегестрированы</div>',
                    //     })
                    // }
                    return;
                }
                this.errors = response.errors || 'При регистрации произошла ошибка. Повторите попытку позже';
                this.requestsState.registration = false;
            });
        },

        sign(data) {
            if (!this.$refs.componentSiger) {
                return Promise.reject('Невозможно создать подпись');
            }
            return this.$refs.componentSiger.sign(data);
        },

        async onSubmit(e) {
            e.preventDefault();

            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) return;

            this.requestsState.registration = true;
            this.requestDocsAgreement().then(({ user, org }) => {
                    const promises = [];
                    promises.push(this.sign(user));
                    if (org) {
                        promises.push(this.sign(org));
                        promises.push(this.sign(JSON.stringify(this.getOrgDataSign())));
                    }

                    return Promise.all(promises);
                    // return Promise.resolve(Object.values(TEST_AGREEMENTS))
                })
                .then(([userAgreement, signedOrgData, organizationConfirm]) => {
                    if (userAgreement) {
                        this.registration(userAgreement, organizationConfirm, signedOrgData);
                        return;
                    }
                    this.requestsState.registration = false;
                })
                // .catch((err) => {
                //     this.errors = err;
                // });
        },

        getCertStamp() {
            if(!this.cert) {
                return;
            }

            return api.getCertStamp({
                cert: this.cert.getData()
            })
            .then((data) => this.certStamp = data)
        },

        checkUserExists() {
            if(!this.user.inn || !this.user.snils) {
                return Promise.reject('Невозможно проверить пользователя');
            }

            return api.checkUserExists({
                inn: this.user.inn,
                snils: this.user.snils,
            })
        },

        getValidityMessages(value) {
            if(Array.isArray(value.$errors)) {
                return value.$errors.map((error) => error.$message)
            }
            if(value.$message) {
                return [value.$message];
            }

            return [];
        }
    },
    created() {
        api.setUrl(this.REGISTRATION_AJAX_URL);
        this.user.phone = '+7 (___) ___-__-__';
    },
    mounted() {},
};
